import { getPwaInstallPrompt, removePwaInstallPrompt } from "@/pwa/install";
import { useCallback, useMemo } from "react";
import { useState } from "react";
import { useIsRunningAsPWA } from "./isRunningAsPWA";

export function usePwaInstallPrompt() {
  const isInstallPromptSupported = useMemo(() => {
    return "onbeforeinstallprompt" in window;
  }, []);

  const isRunningAsPWA = useIsRunningAsPWA();

  const [active, setActive] = useState(isInstallPromptSupported ? true : false);

  const onIntall = useCallback(async () => {
    const pwaInstallPrompt = getPwaInstallPrompt();

    if (!pwaInstallPrompt) {
      return;
    }

    pwaInstallPrompt.prompt();

    const { outcome } = await pwaInstallPrompt.userChoice;

    removePwaInstallPrompt();

    if (outcome === "accepted") {
      return true;
    } else if (outcome === "dismissed") {
      return false;
    }
  }, []);

  const isActive = isRunningAsPWA ? false : active;

  return { active: isActive, onIntall, isInstallPromptSupported };
}
